import startCase from 'lodash/startCase';
import lowerCase from 'lodash/lowerCase';

export function beautifyComputationName(
  computationName: string | null
): string | null {
  return startCase(lowerCase(computationName));
}
